export const tripStage = {
	ORIGIN: 'Origem',
	DESTINY: 'Destino',
}

export const PRIORITY_TERM = 'TODOS'
